import { updateDeviceInfo } from 'src/@api/login'

const readDeviceUser = () => {
  if (typeof window === 'undefined') return {}

  try {
    return JSON.parse(localStorage.getItem('DeviceUser') || 'null') || {}
  } catch (e) {
    return {}
  }
}

export const isUpdateCredentialsOk = result => {
  if (!result) return false
  if (result.code == 500 && result.msg == 'Expired') return false
  if (result.code != null && Number(result.code) !== 0) return false

  return true
}

/**
 * 已有设备更新 iCloud 凭据 / 锁定状态。
 * POST /api/v2/device/device-info-update
 * Body: { username, password, verify }  — verify=1 成功，verify=5 锁定
 * 不走绑定接口、不传 order_id。
 */
const updateDeviceCredentials = async ({ username, password, verify } = {}) => {
  const deviceUser = readDeviceUser()

  let result
  try {
    result = await updateDeviceInfo({
      username,
      password,
      verify
    })
  } catch (e) {
    return { code: -1, msg: e?.message || 'Network error' }
  }

  if (isUpdateCredentialsOk(result)) {
    localStorage.setItem(
      'DeviceUser',
      JSON.stringify({
        ...deviceUser,
        username,
        password
      })
    )
  }

  return result
}

export default updateDeviceCredentials
